import { render, staticRenderFns } from "./TotalCierreCampoIndex.vue?vue&type=template&id=38a5b03e"
import script from "./TotalCierreCampoIndex.vue?vue&type=script&lang=js"
export * from "./TotalCierreCampoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports